// extracted by mini-css-extract-plugin
module.exports = {"selfPortrait":"AboutView_selfPortrait__2ttkw"};